export default __webpack_public_path__ + "static/media/flag-afghanistan.6c7693c1.svg";